import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

export default function Text({
  defaultTag = 'span',
  tag,
  variant,
  color,
  dark,
  light,
  bold,
  uppercase,
  className,
  ...props
}) {
  defaultTag = 'span';
  const Tag = tag ? tag : defaultTag;
  const colorClass = styles[color];

  return (
    <Tag
      className={classnames(
        {
          [styles.uppercase]: uppercase,
          [styles.primary]: dark,
          [styles.darkBgPrimary]: light,
          [styles.bold]: bold
        },
        className,
        colorClass,
        styles[variant]
      )}
      {...props}
    />
  );
}
